// CodeNekt for Fleet — color tokens.
//
// DUAL-MODE NOTE:
//  • Surface / text / border tokens point to CSS variables (--c-*) defined per
//    mode in index.css and injected by ThemeModeProvider. They re-theme LIVE
//    across the whole app (react-jss + inline styles) when data-theme flips.
//  • Brand & status colors stay as concrete hex (constant across modes), which
//    also keeps alpha-hex concatenation sites (e.g. `colors.primary + "20"`)
//    working unchanged.
export const colors = {
  // ---- Brand (constant hex) ----
  fleetNavy: "var(--c-nav)",
  fleetBlue: "#2563EB",
  nektiaBlue: "#3B82F6",
  electricBlue: "#60A5FA",

  // ---- Canvas & surfaces (themed via CSS vars) ----
  deepSpace: "var(--c-canvas)",
  canvas: "var(--c-canvas)",
  darkSurface: "var(--c-surface)",
  surface: "var(--c-surface)",
  elevatedSurface: "var(--c-surface-2)",
  surfaceElevated: "var(--c-surface-2)",
  surfaceHover: "var(--c-surface-hover)",

  // ---- Text (themed via CSS vars) ----
  primaryText: "var(--c-text)",
  secondaryTextColor: "var(--c-text-2)",
  mutedText: "var(--c-muted)",

  // ---- Status (constant hex) ----
  successColor: "#22C55E",
  warningColor: "#F59E0B",
  errorColor: "#EF4444",

  // ================= LEGACY KEYS =================
  darkblack: "var(--c-text)", // was --c-canvas: used only as a TEXT color, so it must follow text (light on dark, dark on light)
  BLACK: "var(--c-text)",
  WHITE: "#F8FAFC", // text on colored/dark backgrounds — constant
  primary: "#2563EB", // concat-prone -> hex
  secondary: "#3B82F6", // concat-prone -> hex
  tertiary: "#EF4444",
  default: "var(--c-canvas)",
  success: "#22C55E", // concat-prone -> hex
  error: "#EF4444",
  info: "#3B82F6", // concat-prone -> hex
  bgcolor: "var(--c-canvas)",
  greydark: "var(--c-muted)", // now themed (alpha-concat sites refactored to rgba)
  primaryLight: "var(--c-surface-2)",
  primaryDark: "#1D4ED8",

  // Secondary colors
  secondaryLight: "var(--c-surface-2)",
  secondaryDark: "#1E40AF",

  // Status colors
  successLight: "#14331f",
  warning: "#F59E0B",
  warningLight: "#3a2a0a",
  errorLight: "#3a1414",
  infoLight: "#0c2030",

  // Text colors
  textPrimary: "var(--c-text)",
  textSecondary: "var(--c-text-2)",
  textDisabled: "var(--c-muted)",

  // Background colors
  white: "var(--c-surface)", // legacy "white" was used as a card surface
  backgroundLight: "var(--c-surface-2)",

  // Border colors
  borderLight: "var(--c-border)",
  borderDark: "var(--c-border-strong)",

  // Gradient colors
  gradientStart: "var(--c-surface-2)",
  gradientEnd: "var(--c-canvas)",

  // Chart colors
  chartPrimary: "#2563EB",
  chartSecondary: "#60A5FA",

  // Hover states
  hoverLight: "rgba(37, 99, 235, 0.08)",
  hoverDark: "rgba(37, 99, 235, 0.16)",
};
